module.exports = __webpack_public_path__ + "media/svg/FileTextFill-5b16e24c.svg";